import { render, staticRenderFns } from "./VerTodas.vue?vue&type=template&id=5f0633bd&scoped=true"
import script from "./VerTodas.vue?vue&type=script&lang=js"
export * from "./VerTodas.vue?vue&type=script&lang=js"
import style0 from "./VerTodas.vue?vue&type=style&index=0&id=5f0633bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0633bd",
  null
  
)

export default component.exports